/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { Component } from 'react';

import ValidationRules from './ValidationRules';

function ValidationHOC(WrapperComponent, formState) {
    return class extends Component {
        constructor(props) {
            super(props);
            this.state = {
                form: formState,
                formIsValid: false,
            };
            this.fieldProps = {};
        }

        componentDidMount() {
            this.clearFormState();
        }

        getFormValidationState = (updateFormStatus, formData) => {
            const { form: formConfig } = this.state;
            const FormFieldAlert = Object.keys(formConfig).map((key) => {
                const form = formConfig[key];
                if (form) {
                    const { required, flagError, alert } = form;
                    const flagIsError = (alert) || flagError;
                    const getProps = this.fieldProps[key];
                    let fieldValue = formData[key] || '';
                    if (!fieldValue && getProps) {
                        const fieldProps = getProps();
                        fieldValue = (fieldProps.val) ? fieldProps.val : '';
                    }
                    const isFieldHaveValue = (fieldValue.toString().length > 0);
                    if ((required && !isFieldHaveValue) || flagIsError) {
                        return true;
                    }
                    return false;
                }
                return false;
            });
            let formIsValid = true;
            if (FormFieldAlert.indexOf(true) >= 0) {
                formIsValid = false;
            }
            this.setState({
                formIsValid,
            });
            if (updateFormStatus) {
                updateFormStatus(formIsValid);
            }
        }

        getTextFieldProps = (getProps) => {
            const textFieldProps = getProps();
            this.fieldProps[textFieldProps.name] = getProps;
        };

        clearFormState = (updateFormStatus) => {
            const updateState = { ...this.state };
            const { form } = this.state;
            Object.keys(form).forEach((fieldName) => {
                updateState.form[fieldName].flagError = false;
                updateState.form[fieldName].errorMessage = '';
                updateState.form[fieldName].alert = false;
            });
            updateState.formIsValid = false;
            this.setState(updateState);
            if (updateFormStatus) {
                updateFormStatus(updateState.formIsValid);
            }
        }

        validateFormFields = (fieldsToValidate, formData, skipValidation, updateFormStatus) => {
            const { form } = this.state;
            const fieldConfig = { ...form };
            const fields = fieldsToValidate || Object.keys(fieldConfig);
            const updateFieldValidation = fieldConfig;
            const skipValid = !!(skipValidation);
            fields.forEach((fieldName) => {
                const getProps = this.fieldProps[fieldName];
                if (getProps) {
                    const fieldProps = getProps();
                    const fieldValue = formData[fieldName];
                    if ((fieldValue && !fieldProps.flagError) || fieldProps.flagError || fieldValue === '') {
                        const validateAider = {
                            ...fieldProps,
                            value: fieldValue,
                        };
                        const validationReturn = ValidationRules.ValidateField(validateAider, fieldName, skipValid);
                        updateFieldValidation[fieldName].flagError = validationReturn.flagError;
                        updateFieldValidation[fieldName].errorMessage = validationReturn.errorMessage;
                        if (validationReturn.alert !== null) {
                            updateFieldValidation[fieldName].alert = validationReturn.alert;
                        }
                    }
                }
            });
            this.setState((prevState) => ({
                ...prevState,
                form: updateFieldValidation,
            }));
            this.getFormValidationState(updateFormStatus, formData);
        }

        validateFormFieldsOnSubmit = (fieldsToValidate, formData, skipValidation, updateFormStatus) => {
            const { form } = this.state;
            const fieldConfig = { ...form };
            const fields = fieldsToValidate || Object.keys(fieldConfig);
            const updateFieldValidation = fieldConfig;
            const skipValid = !!(skipValidation);
            fields.forEach((fieldName) => {
                const getProps = this.fieldProps[fieldName];
                if (getProps) {
                    const fieldProps = getProps();
                    const fieldValue = formData[fieldName]?.trim();
                    const validateAider = {
                        ...fieldProps,
                        value: fieldValue,
                    };

                    const validationReturn = ValidationRules.ValidateField(validateAider, fieldName, skipValid);
                    updateFieldValidation[fieldName].flagError = validationReturn.flagError;
                    updateFieldValidation[fieldName].errorMessage = validationReturn.errorMessage;
                    if (validationReturn.alert !== null) {
                        updateFieldValidation[fieldName].alert = validationReturn.alert;
                    }
                }
            });
            this.setState((prevState) => ({
                ...prevState,
                form: updateFieldValidation,
            }));
            this.getFormValidationState(updateFormStatus, formData);
        }

        // onblur
        handleOnBlur = (key, response, formData, validateFor, updateFormStatus) => {
            const updateVal = { ...this.state };
            if (Object.prototype.hasOwnProperty.call(response, 'alert')) {
                updateVal.form[key].alert = response.alert;
            }
            updateVal.form[key].flagError = response.flagError;
            updateVal.form[key].errorMessage = response.errorMessage;
            const that = this;
            this.setState(updateVal, () => {
                if (validateFor) {
                    that.validateFormFields(validateFor, formData, false, updateFormStatus);
                } else {
                    that.getFormValidationState(updateFormStatus, formData);
                }
            });
        }

        updateFormFieldState = (nextState, validateFor, formData, skipValidation) => {
            this.setState((prevState) => ({
                ...prevState.form,
                nextState,
            }), () => {
                if (validateFor) {
                    this.validateFormFields(validateFor, formData, skipValidation);
                }
            });
        }

        render() {
            const { form, formIsValid } =  this.state;
            return (
                <WrapperComponent
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...this.props}
                    validateFormFields={this.validateFormFields}
                    validateFormFieldsOnSubmit={this.validateFormFieldsOnSubmit}
                    getTextFieldProps={this.getTextFieldProps}
                    formFieldState={form}
                    formIsValid={formIsValid}
                    handleOnBlur={this.handleOnBlur}
                    updateFormFieldState={this.updateFormFieldState}
                    clearFormState={this.clearFormState}
                />
            );
        }
    };
}

export default ValidationHOC;
